import { useMutation } from "@tanstack/react-query";
import modalStore from "stores/ModalStore";
import { useNaverLogin } from "views/naver/hooks/useNaverLogin";
import { getConnectionService, getShopList } from "views/setting/services/connectionService";

// 사업자번호 조회 및 연동 매장 목록 조회
export const useConnectionMutation = (rootStore: any) => {
  const { layerStore, searchStore, settingStore } = rootStore;
  const { naverLogin } = useNaverLogin(rootStore);
  const shopCd = searchStore.getShopCd;
  const token = searchStore.getToken;
  const endPoint = () => {
    if (layerStore.tp === "DDY") return "ddangyo";
    if (layerStore.tp === "YGY") return "yogiyo";
    return "oltteaah";
  };
  return useMutation({
    mutationFn: async (bizNo: string) => {
      const validateBizNo = await getConnectionService({ rootStore, shopCd, bizNo, token });
      return { validateBizNo };
    },
    onSuccess: async data => {
      const { validateBizNo } = data ?? {};

      // 사업자 번호 인증 실패
      if (validateBizNo.resultCode === "DM0001") {
        rootStore.layerStore.setLayerBizNo(true);
        settingStore.setShopBizNo(validateBizNo.bizNo);
        return;
      }

      // 네이버 연동
      if (layerStore.tp === "NAVERBOOKING") {
        modalStore.closeModal("DeliveryConnectBusiness");
        naverLogin({
          clientId: process.env.REACT_APP_NAVER_CLIENT_ID!,
          redirectUri: process.env.REACT_APP_NAVER_REDIRECT_URI!,
        });
        return;
      }

      const shopList = await getShopList({
        rootStore,
        shopCd,
        bizNo: validateBizNo.bizNo || "",
        token,
        name: endPoint(),
      });

      modalStore.closeModal("DeliveryConnectBusiness");
      modalStore.openModal("DeliveryConnectPosPick", {});
      rootStore.settingStore.setDdyShopList(shopList ?? []);
    },
    onError: error => {
      console.error("매장 목록 조회 실패:", error);
      rootStore.layerStore.setDlvConnectTypeView(layerStore.tp + "_ERR");
      rootStore.layerStore.setLayerCompleteView(true);
      rootStore.layerStore.setLayerLoadingView(false);
      modalStore.closeModal("DeliveryConnectBusiness");
      
    },
  });
};
